import { allFindingTypeFiltersEnum } from '../../finding/models/findingTypeFilterEnum';
import findingTypeEnum from '../../finding/models/findingTypeEnum';
import priorityEnum from '../../finding/models/priorityEnum';
import creationModeEnum from '../../finding/models/creationModeEnum';
import { adminOnlyLabelFiltersEnum, allLabelFiltersEnum } from '../../finding/models/findingLabelFilterEnum';

const isImmediateThreat = (finding, filerValues) =>
  filerValues.findingType.includes(allFindingTypeFiltersEnum.immediate) &&
  finding.type === findingTypeEnum.threat &&
  finding.priority === priorityEnum.immediate;

const isInvestigateThreat = (finding, filerValues) =>
  filerValues.findingType.includes(allFindingTypeFiltersEnum.investigation) &&
  finding.type === findingTypeEnum.threat &&
  finding.priority === priorityEnum.investigation;

const isManualNote = (finding, filerValues) =>
  filerValues.findingType.includes(allFindingTypeFiltersEnum.noteManual) &&
  finding.type === findingTypeEnum.note &&
  finding.creationMode === creationModeEnum.manual;

const isAutomaticNote = (finding, filerValues) =>
  filerValues.findingType.includes(allFindingTypeFiltersEnum.noteAutomatic) &&
  finding.type === findingTypeEnum.note &&
  finding.creationMode === creationModeEnum.automatic;

const isDismissedFinding = (finding, filerValues) =>
  filerValues.findingType.includes(allFindingTypeFiltersEnum.dismissed) && finding.type === findingTypeEnum.dismissed;

const isUnclassifiedFinding = (finding, filerValues) =>
  filerValues.findingType.includes(allFindingTypeFiltersEnum.unclassified) && finding.type === findingTypeEnum.unclassified;

const isFindingLabelUnknown = (finding, filerValues, clientCategories) => {
  const labelInClientCategories = clientCategories.some((category) => category.key === finding.label);

  const labelInAdminOnlyFilters = Object.values(adminOnlyLabelFiltersEnum).includes(finding.label);

  return filerValues.findingClass.includes(allLabelFiltersEnum.unknown) && !labelInClientCategories && !labelInAdminOnlyFilters;
};

const getFilteredFindings = (findings = [], filerValues = {}, clientCategories) =>
  findings.filter((finding) => {
    const isFindingTypeValid =
      !filerValues.findingType || filerValues.findingType.length === 0
        ? true
        : isImmediateThreat(finding, filerValues) ||
          isInvestigateThreat(finding, filerValues) ||
          isManualNote(finding, filerValues) ||
          isAutomaticNote(finding, filerValues) ||
          isDismissedFinding(finding, filerValues) ||
          isUnclassifiedFinding(finding, filerValues);

    const isFindingClassValid =
      !filerValues.findingClass || filerValues.findingClass.length === 0
        ? true
        : isFindingLabelUnknown(finding, filerValues, clientCategories) || filerValues.findingClass.includes(finding.label);

    return isFindingTypeValid && isFindingClassValid;
  });

export default getFilteredFindings;
